// extracted by mini-css-extract-plugin
export default {"body_wrapper":"Activity_body_wrapper__S0w8f"};